import type { App } from 'vue'
import { Input, Layout, Select } from 'ant-design-vue'

// 注入 vxe-table
import VXETable from 'vxe-table'
import { Button } from './Button'

export function registerGlobComp(app: App) {
    app.use(Input).use(Button).use(Select).use(Layout).use(VXETable)
}
